import React from 'react'
import {
	BadgeAlertIcon,
	BadgeCheckIcon,
	BadgeInfoIcon,
	LoaderCircleIcon,
	TriangleAlertIcon,
	XIcon,
} from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = 'system' } = useTheme()

	return (
		<div onPointerDown={(e) => e.stopPropagation()}>
			<Sonner
				theme={theme as ToasterProps['theme']}
				className='toaster group'
				position='bottom-left'
				icons={{
					success: <BadgeCheckIcon className='size-4 text-success' />,
					info: <BadgeInfoIcon className='text-info size-4' />,
					error: <TriangleAlertIcon className='size-4 text-destructive' />,
					warning: <BadgeAlertIcon className='size-4 text-warning' />,
					loading: <LoaderCircleIcon className='size-4 animate-spin' />,
					close: <XIcon />,
				}}
				closeButton
				style={
					{
						'--normal-bg': 'var(--popover)',
						'--normal-text': 'var(--popover-foreground)',
						'--normal-border': 'var(--border)',
						'--toast-close-button-start': 'unset',
						'--toast-close-button-end': '4px',
						'--toast-close-button-transform': 'unset',
					} as React.CSSProperties
				}
				toastOptions={{
					classNames: {
						toast:
							'!bg-background !text-foreground !border-border !border !shadow-lg !rounded-lg !pr-6 group toast group-[.toaster]:pointer-events-auto',
						description: '!text-muted-foreground',
						content: '!w-full',
						closeButton:
							'!size-6 !top-1 [&>svg]:!size-4 !bg-transparent !border-none opacity-50 hover:opacity-100',
						actionButton:
							'!bg-transparent !border-border !border !text-foreground !rounded-md',
						cancelButton:
							'!group-[.toast]:bg-muted !group-[.toast]:text-muted-foreground',
					},
				}}
				{...props}
			/>
		</div>
	)
}

export { Toaster }
